var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandBb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4438 11.5L20.0922 9.26563L0.498444 22.5L16.9984 33.5L33.4984 22.5L26.6234 17.9453L18.3734 23.5313L21.9828 25.8516L16.9984 28.8594L7.63125 22.5L23.4438 11.5Z",
    fill: "#FCFC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37344 28.9453L3.93594 26.625L0.498444 28.9453V33.5L7.37344 28.9453Z",
    fill: "#FCFC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4984 11.5L16.9984 0.5L0.498444 11.5L7.37344 16.0547L15.6234 10.4688L12.0141 8.14844L16.9984 5.14063L26.3656 11.5L10.5531 22.5L13.9047 24.7344L33.4984 11.5Z",
    fill: "#FCFC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4984 5.05469V0.5L26.6234 5.05469L30.0609 7.375L33.4984 5.05469Z",
    fill: "#FCFC30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandBb);
export default __webpack_public_path__ + "static/media/brand_bb.27f5a12f5e4d00a33cb2649ef0e198b7.svg";
export { ForwardRef as ReactComponent };